<template>
  <div
    class="login-container"
    :style="{ '--bg': 'url(' + icon.bg + ')' }"
    v-if="isShowLogin"
  >
    <div
      class="login-box flex-start-center"
      :style="{ '--loginbg': 'url(' + icon.loginbg + ')' }"
    >
      <div class="logo-content">
        <el-image
          class="logo-1"
          :src="icon.logo"
        />
      </div>
      <div class="sub-title">
        节能电机，助力企业节能降本
      </div>
      <el-input
        v-model="form.userName"
        class="input"
        placeholder="请输入账号"
      >
        <el-image
          slot="prefix"
          class="el-input__icon icon icon-user"
          :src="icon.user"
        />
      </el-input>
      <el-input
        v-model="form.password"
        class="input"
        :type="passwordFieldType"
        placeholder="请输入密码"
        @keyup.enter.native="handleLogin"
      >
        <el-image
          slot="prefix"
          class="el-input__icon icon icon-user"
          :src="icon.password"
        />
        <template slot="suffix">
          <el-image
            :src="iconClass"
            class="password-icon"
            @click="togglePasswordVisibility"
          />
          <!-- <i :class="iconClass" @click="togglePasswordVisibility"></i> -->
        </template>
      </el-input>
      <!-- <div class="authorize">
        <el-checkbox v-model="authorize"
          >已阅读并同意用户协议和隐私政策</el-checkbox
        >
      </div> -->
      <el-button
        class="login-btn"
        type="primary"
        :loading="loading"
        @click="handleLogin"
      >
        登录
      </el-button>
      <!-- <div class="btm flex-between-center">
        <div class="register">
          还没有账号？<span class="btn">立即注册</span>
        </div>
        <div class="forget">忘记密码？</div>
      </div> -->
    </div>
  </div>
  <div v-else></div>
</template>
<script>
import { generaMenu } from '@/api/index'
import { menuData } from '@/utils/menuData'
import { login ,loginWithG5,getUserInfoG5,loginG5And} from '@/api/index'
import { filterMenuDataFn, getFirstValidPath,getQueryobject } from '@/utils/index'
import Cookies from 'js-cookie';
export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      form: {
        userName: '',
        password: ''
      },
      authorize: false,
      hidePwd: true,
      icon: {
        bg: require('@/assets/images/bg.png'),
        logo: require('@/assets/images/logoLogin.png'),
        loginbg: require('@/assets/images/login-bg.png'),
        user: require('@/assets/images/user-name.png'),
        password: require('@/assets/images/password.png'),
        passwordEye1: require('@/assets/images/passwordEye1.png'),
        passwordEye2: require('@/assets/images/passwordEye2.png')
      },
      isPasswordVisible: false,
      userCode: '',
      agentCode: '',
      isShowLogin:false
    }
  },
  computed: {
    passwordFieldType() {
      return this.isPasswordVisible ? 'text' : 'password'
    },
    iconClass() {
      return this.isPasswordVisible
        ? this.icon.passwordEye1
        : this.icon.passwordEye2 // 根据实际使用的图标库调整类名
    }
  },
  methods: {
    async handleLogin() {
      if (!this.form.userName || !this.form.password) {
        this.$message({
          message: '请填写用户名和密码',
          type: 'warning'
        })
        return
      }
      // if (!this.authorize) {
      //   this.$message({
      //     message: "请阅读并同意用户协议和隐私政策",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.loading = true

      loginG5And({
        username: this.form.userName,
        password: this.form.password
      })
        .then(async(res) => {
          this.$message.success('登录成功')
          await this.$store.dispatch('user/setToken', res.data.token)
          await this.$store.dispatch('user/getUserInfo')
          await this.AllAuthByUserFn()
          sessionStorage.setItem('refreshToken',res.data.refreshToken)
        })
        .catch((err) => {
          // console.log('🚀 ~ handleLogin ~ err:', err)
          // this.$message({
          //   type: 'error',
          //   message: '登录失败,账号或密码错误'
          // })
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 定义一个函数，用于过滤 children 数组中的 bol 为 true 的子对象
    filterChildren(submenu) {
      if (submenu) {
        return submenu.filter((child) => child.meta.showInSidebar)
      }
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible
    },
    async AllAuthByUserFn() {
      await generaMenu(this.$store.state.user.userInfo.customerId.id).then(res => {
        let menuList = []
        let filterMenuData = []
        // if (this.$store.getters.userInfo.authority == "TENANT_ADMIN") { // 如果是平台管理员
        //   filterMenuData = menuData.filter((item) => item.title == "平台管理");
        // } else { // 如果不是平台管理员，则根据接口获取的菜单权限去展示菜单
        menuList = res.data?.data?.menuList || []
        filterMenuData = filterMenuDataFn(menuData, menuList)
        const orgIDList = res.data.data.orgList
        localStorage.setItem('orgIDList', JSON.stringify(orgIDList))
        // }
        this.$store.dispatch('menu/setMenuListCode', menuList)
        this.$store.dispatch('menu/setMenuList', filterMenuData)
        const orgList = res?.data?.data?.orgList || []
        const customerInfo = {
          customerName: res?.data?.data?.customerName || '',
          customerId: res?.data?.data?.customerId || ''
        }
        const roleList = res?.data?.data?.roleList || []
        const buttonList = res.data.data.buttonList
        const userName = res.data.data.userName || ''
        this.$store.dispatch('menu/setOrgList', orgList)
        this.$store.dispatch('menu/setCustomerInfo', customerInfo)
        this.$store.dispatch('menu/setRoleList', roleList)
        this.$store.dispatch('menu/setButtonList', buttonList)
        this.$store.dispatch('menu/setUserName', userName)
        const path = getFirstValidPath(filterMenuData)
        this.$router.push(path)
      })
    },
      //从G5跳转
    async handleLoginG5() {
      // 获取 cookies 中的 code
      let codeCookies = Cookies.get('code')
      console.log(codeCookies,'codeCookies')
      loginWithG5({
        userCode: this.userCode,
        agentCode: this.agentCode,
        code:codeCookies
      })
        .then(async(res) => {
          console.log(res.data.token,'res.data.token')
          await this.$store.dispatch('user/setToken', res.data.token)
          await this.$store.dispatch('user/getUserInfo')
          await this.AllAuthByUserFn()
        })
        
    },
    //获取微云信息
    getUserInfoG5() {
      getUserInfoG5({})
        .then((res) => {
          console.log(res.data,'微云用户信息')
          this.userCode = res.data.data.account
          this.agentCode = res.data.data.ecid
          if(this.userCode){        
            this.handleLoginG5()
            this.isShowLogin = false
          }else{
            this.isShowLogin = true
          }
        }).catch((err)=>{
          this.isShowLogin = true
        })
        
    },
    
  },
  mounted(){
    //非G5跳转
    this.isShowLogin = true
    //G5跳转
    // let isLoginOutG5 = localStorage.getItem('isLoginOutG5')
    // if(isLoginOutG5){
    //   this.isShowLogin = true
    //   localStorage.removeItem('isLoginOutG5')
    // }else{
    //   this.getUserInfoG5()   
    // }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-input__inner {
  background: #272f37 !important;
  border-color: #272f37;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9) !important;
}
::v-deep .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.9) !important;
}
::v-deep .el-input .el-input__clear {
  color: #7fd4fc;
}
.login-container {
  position: relative;
  height: 100vh;
  background-image: var(--bg);
  background-size: cover;
  background-position: center;

  .login-box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    flex-direction: column;
    width: 510px;
    height: 430px;
    // background: #263044;
    background-image: var(--loginbg);
    background-size: cover;
    background-position: center;
    box-shadow: 0px 2px 43px 0px rgba(0, 0, 0, 0.27);
    border-radius: 10px;
    padding: 46px 75px 0 75px;

    .logo-content {
      .logo-1 {
        width: 163px;
        height: 34px;
      }

      .logo-2 {
        width: 156px;
        height: 36px;
        margin-left: 7px;
      }
    }

    .sub-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 20px;
      text-align: center;
      margin: 15px 0 50px 0;
    }

    .input {
      border-radius: 4px;
      margin-bottom: 24px;

      ::v-deep {
        .el-input__inner {
          background: #272f37;
          height: 40px;
        }
      }

      .icon {
        ::v-deep {
          .el-image__inner {
            width: 16px;
            height: 16px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        &.icon-pwd {
          cursor: pointer;
        }
      }
      .password-icon {
        margin-right: 4px;
        ::v-deep {
          .el-image__inner {
            width: 16px;
            height: 16px;
            vertical-align: -14px;
          }
        }
      }
    }

    .authorize {
      width: 100%;
    }

    .login-btn {
      width: 100%;
      height: 40px;
      background: #377dff;
      border-radius: 6px;

      margin: 20px 0;
    }

    .btm {
      width: 100%;

      .register,
      .forget {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #5f6a7a;

        .btn {
          color: #237ffa;
          cursor: pointer;
        }
      }

      .forget {
        color: #237ffa;
        cursor: pointer;
      }
    }
  }
}
</style>
